import {Component, ReactNode} from 'react';
import './SilhouettePopup.scss';
import {
    Container,
    Dialog, DialogContent,
    DialogTitle,
    IconButton, Stack, Typography
} from '@mui/material';
import {GameContext} from '../content/GameContext';
import {Close} from '@mui/icons-material';

export interface StatsPopupProps<Schema> {
    show: boolean;
    onClose: () => void;
    gameContext: GameContext<Schema>;
    streak: number,
    maxStreak: number,
    totalGuesses: number,
    gamesPlayed: number,
    wins: number
}

export class StatsPopup<Schema> extends Component<StatsPopupProps<Schema>> {

    private getTypography = (text: string | number) => {
        return <Typography textAlign={"center"}
                           fontWeight={"bold"}
                           color={"primary.main"}
        >
            {text}
        </Typography>;
    };

    override render(): ReactNode {
        const winPercentage = Math.round(this.props.wins * 100 /
            (this.props.gamesPlayed > 0 ? this.props.gamesPlayed : 1)
        );
        let avgGuesses = this.props.totalGuesses / (this.props.wins > 0 ? this.props.wins : 1);
        avgGuesses = Math.round(avgGuesses * 10) / 10;
        return <Dialog
            open={this.props.show}
            fullWidth={true}
            maxWidth={false}
        >
            <DialogTitle>
                <IconButton aria-label="close" onClick={this.props.onClose} sx={{
                    position: 'absolute',
                    right: 4,
                    top: 4,
                    color: "primary.main"
                }}>
                    <Close/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack direction={"row"}>
                    <Container>
                        {this.getTypography("GAMES PLAYED")}
                        {this.getTypography(this.props.gamesPlayed)}
                    </Container>
                    <Container>
                        {this.getTypography("WIN PERCENT")}
                        {this.getTypography(`${winPercentage}%`)}
                    </Container>
                    <Container>
                        {this.getTypography("AVG GUESSES")}
                        {this.getTypography(avgGuesses)}
                    </Container>
                    <Container>
                        {this.getTypography("CURRENT STREAK")}
                        {this.getTypography(this.props.streak)}
                    </Container>
                    <Container>
                        {this.getTypography("MAX STREAK")}
                        {this.getTypography(this.props.maxStreak)}
                    </Container>
                </Stack>
            </DialogContent>
        </Dialog>;
    }
}
